import { ThemeEvents } from '@theme/events';

/**
 * Keeps theme site-sale prices visible when third-party apps (e.g. Bundlex)
 * overwrite the product page price after initial render.
 */
let isRestoring = false;

/**
 * @param {Element} container
 */
function restoreSiteSalePrice(container) {
  if (!(container instanceof HTMLElement)) return;
  if (container.dataset.siteSaleApplied !== 'true') return;

  const salePrice = container.dataset.siteSalePrice;
  const comparePrice = container.dataset.siteSaleCompare;
  if (!salePrice || !comparePrice) return;

  const saleEl = container.querySelector('.price--on-sale') ?? container.querySelector('.price');
  const compareEl = container.querySelector('.compare-at-price');

  if (saleEl instanceof HTMLElement && saleEl.textContent?.trim() !== salePrice) {
    saleEl.textContent = salePrice;
  }

  if (compareEl instanceof HTMLElement && compareEl.textContent?.trim() !== comparePrice) {
    compareEl.textContent = comparePrice;
  }
}

export function restoreSiteSalePrices() {
  document.querySelectorAll('[data-site-sale-applied="true"]').forEach(restoreSiteSalePrice);
}

function scheduleRestores() {
  restoreSiteSalePrices();
  window.setTimeout(restoreSiteSalePrices, 50);
  window.setTimeout(restoreSiteSalePrices, 250);
  window.setTimeout(restoreSiteSalePrices, 1000);
}

if (typeof window !== 'undefined') {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleRestores);
  } else {
    scheduleRestores();
  }

  window.addEventListener('load', scheduleRestores);
  document.addEventListener(ThemeEvents.variantUpdate, scheduleRestores);

  const observer = new MutationObserver(() => {
    if (isRestoring) return;

    isRestoring = true;
    requestAnimationFrame(() => {
      restoreSiteSalePrices();
      isRestoring = false;
    });
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
    characterData: true,
  });
}
